import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { dateRangeStyles } from "@tJohnstonCompanies/Overrides/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        // border: 10px solid rgb(204, 204, 204);
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        display: block;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
        >div:last-child {
            padding: 0 0 0 10px;
            label {
                color: #000;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 10px 0 0 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            >div[class^="FormFieldStyle"]: last-child {
                > div[class^="FormInputWrapper"] {
                    div[class^="react-calendar"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        left: 0px;
                                    `,
                                    css`
                                        left: 0px;
                                    `,
                                    css`
                                        left: -120px;
                                    `,
                                    css`
                                        left: -60px;
                                    `,
                                    css`
                                        left: 0px;
                                    `,
                                ],
                                "min",
                            )}
                    }
                }
            }
        }
        >div: first-child {
            padding: 0 10px 0 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 0 0 0 0;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        }
    `,
};
dateRangeStyles.datePickerWidth = {
    css: css`
        width: 50%;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100% !important;
                    `,
                    null,
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
};
